(() => {
  'use strict';
  const element = document.getElementById('RepubblicaDiscoveryConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const hidden = config.hidden.split(',').map(value => value.trim().toLowerCase()).filter(Boolean);
  if (!hidden.length) return;
  const allowed = config.vendors.filter(value => !hidden.includes(value.trim().toLowerCase()));
  const key = 'filter.p.vendor';
  const marker = 'rp_discovery_base';
  const initial = new URL(location.href);
  const values = url => url.searchParams.getAll(key).filter(Boolean);
  const isBase = url => url.searchParams.has(marker) || (values(url).length === allowed.length && allowed.every(value => values(url).includes(value)));
  const isListing = url => url.origin === location.origin && (url.pathname === config.searchPath || /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?collections\/[^/]+$/.test(url.pathname));
  const required = config.required || isBase(initial);
  const publicUrl = raw => {
    const url = new URL(raw, location.origin);
    if (isBase(url)) url.searchParams.delete(key);
    url.searchParams.delete(marker);
    return url.toString();
  };
  const requestUrl = (raw, force = false) => {
    const url = new URL(raw, location.origin);
    if (!isListing(url) || (!force && !required)) return url.toString();
    const selected = isBase(url) ? [] : values(url);
    url.searchParams.delete(marker);
    url.searchParams.delete(key);
    if (!selected.length) {
      allowed.forEach(value => url.searchParams.append(key, value));
      url.searchParams.set(marker, '1');
    } else {
      const visible = selected.filter(value => !hidden.includes(value.trim().toLowerCase()));
      (visible.length ? visible : ['__repubblica_no_visible_vendor__']).forEach(value => url.searchParams.append(key, value));
    }
    return url.toString();
  };
  const normalise = (root, raw) => {
    const url = new URL(raw, location.origin);
    if (!isBase(url)) return;
    root.querySelectorAll('input[name="filter.p.vendor"]').forEach(input => {
      input.checked = false;
      input.removeAttribute('checked');
      input.closest('.ProductFilters__Item')?.classList.remove('Active');
    });
    root.querySelectorAll('[data-discovery-vendor-tag="filter.p.vendor"]').forEach(item => item.remove());
    root.querySelectorAll('[data-filter-tags]').forEach(group => {
      if (!group.querySelector('[data-filter-tag]')) group.remove();
    });
    root.querySelectorAll('a[href]').forEach(link => {
      const target = new URL(link.getAttribute('href'), location.origin);
      if (target.origin === location.origin && isBase(target)) link.setAttribute('href', publicUrl(target));
    });
  };
  window.repubblicaDiscovery = { requestUrl, publicUrl, normalise, filteringRequired: required, isHiddenVendor: value => hidden.includes(String(value || '').trim().toLowerCase()) };
  if (isListing(initial)) {
    const next = requestUrl(initial);
    if (next !== initial.toString()) {
      window.repubblicaDiscovery.initialRequest = next;
      document.documentElement.classList.add('rp-discovery-loading');
    }
    if (isBase(initial)) history.replaceState(history.state, '', publicUrl(initial));
    document.addEventListener('DOMContentLoaded', () => normalise(document, initial), { once: true });
  }
})();
